enum ParticipantRole {
  CUSTOMER = 'CUSTOMER',
  AGENT = 'AGENT',
  SYSTEM = 'SYSTEM',
  SUPERVISOR = 'SUPERVISOR',
}

export default ParticipantRole;
